import { compose, path } from 'ramda'
import datetimeStringToTimestampConverter from '../date/converter/datetimeStringToTimestampConverter'

const formatOffer = ({ id: iri, attributes, ...offerData }) => ({
  ...offerData,
  ...attributes,
  iri,
})

const formatOfferLine = ({ id: iri, attributes, ...offerLineData }) => ({
  ...offerLineData,
  ...attributes,
  iri,
})

export const getOffersFactory = (fetchPath) => async ({ contactId } = {}) => {
  const offers = await fetchPath.run({
    path: '/yoda/api/offers',
    parameters: {
      status: 'active',
      shared: true,
      // sharedWithCustomers: true,
      contactId,
      itemsPerPage: 999,
    },
    jsonPath: ['content', 'data'],
  }).then((offers) => offers.map(formatOffer))

  const offerLineGroups = await Promise.all(
    offers.map(({ id, cacheThreshold }) => (
      fetchPath.run({
        path: '/yoda/api/offer-lines',
        parameters: {
          offer: id,
          itemsPerPage: 999,
        },
        jsonPath: ['content', 'data'],
        earliestPermittedCacheHit: datetimeStringToTimestampConverter(cacheThreshold),
      }).then((offerLines) => offerLines.map(formatOfferLine))
    )),
  )

  return offers.map((offer) => {
    const offerLines = offerLineGroups.find(([offerLine]) => (
      offerLine && offerLine.offer === offer.iri
    ))

    return {
      ...offer,
      offerLines: offerLines || [],
    }
  })
}

export const getOfferByIdFactory = (fetchPath) => async (offerId, { loadLines = true } = {}) => {
  const offer = await fetchPath.run({
    path: `/yoda/api/offers/${offerId}`,
    jsonPath: ['content', 'data'],
  })
  const offerLines = loadLines && await fetchPath.run({
    path: '/yoda/api/offer-lines',
    parameters: {
      offer: offerId,
      itemsPerPage: 999,
    },
    jsonPath: ['content', 'data'],
    earliestPermittedCacheHit: compose(
      datetimeStringToTimestampConverter,
      path(['attributes', 'cacheThreshold']),
    )(offer),
  })

  return formatOffer({
    ...offer,
    offerLines: loadLines && offerLines.map(formatOfferLine),
  })
}

export const shareOfferFactory = (fetchPath) => ({
  offer: { iri },
  contact,
  emailList,
  message,
}) => (
  fetchPath.run({
    path: '/yoda/api/offer-share-requests',
    method: 'POST',
    data: {
      offer: iri,
      contact,
      emailList,
      message,
    },
  })
)
